@use "app/styles/colors" as colors;

.section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 3rem;
  margin-bottom: calc(min(0.55rem, max(0.3rem, 1.4dvw)) * 26);
  margin-left: var(--root-bleed);
  margin-right: var(--root-bleed);
  padding: 2rem;
  border-radius: 2rem;
  border: 3px solid transparent;
  @include colors.section("blue");

  @media (prefers-color-scheme: light) {
    background-color: var(--section-color-dim);
  }
  @media (prefers-color-scheme: dark) {
    background-origin: border-box;
    background-clip: padding-box, border-box;
    background-image:
      linear-gradient(var(--color-background), var(--color-background)),
      linear-gradient(to right, var(--section-color), var(--section-color-alt));
  }
  @media (min-width: 48rem) {
    padding: 3rem;
  }
  @media (min-width: 64rem) {
    border: none;
    background-image: none;
    background-color: transparent;
    margin-bottom: 0;
    padding: 0 4rem;
    flex-direction: row;
    align-items: center;
  }
}

.content {
  display: flex;
  flex-direction: column;
  max-width: 35rem;
  @media (min-width: 64rem) {
    order: 1;
  }
  @media (min-width: 90rem) {
    margin-right: 0;
  }

  h2 {
    font-size: max(2.8rem, min(3.3rem, 8dvw));
    margin-bottom: 1.25rem;
  }

  p {
    font-size: 1.1rem;
    margin: 1rem 0;
  }
}

.headingText {
  display: inline-flex;
  color: var(--section-color-dark);
  @media (prefers-color-scheme: dark) {
    color: var(--color-foreground);
  }
  @media (prefers-color-scheme: light) and (min-width: 64rem) {
    background-clip: text;
    color: transparent;
    background-image: linear-gradient(
      to right,
      var(--section-color-dark),
      var(--section-color-light)
    );
  }
}

.demo {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: -30em;
  font-size: min(0.55rem, max(0.3rem, 1.4dvw));
  align-items: center;
  border-radius: 2rem;
  background-origin: border-box;
  background-clip: padding-box, border-box;
  @media (min-width: 58rem) {
    align-self: flex-end;
    margin-top: -6rem;
    justify-content: flex-end;
  }
  @media (min-width: 64rem) {
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 3.75rem;
    padding: 4rem;
    padding-top: 6rem;
    padding-bottom: 5rem;
    margin-left: var(--root-bleed);
    @media (prefers-color-scheme: light) {
      &::before {
        z-index: -1;
        pointer-events: none;
        user-select: none;
        content: "";
        position: absolute;
        inset: 0;
        background: var(--section-color-dim);
        border-radius: 2rem;
        clip-path: polygon(0 0, 4rem 0, 0 4rem, 0 100%, 100% 100%, 100% 0);
      }
    }
    @media (prefers-color-scheme: dark) {
      border: 3px solid transparent;
      border-left: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      background-image:
        linear-gradient(var(--color-background), var(--color-background)),
        linear-gradient(
          to right,
          transparent,
          var(--section-color-alt),
          var(--section-color)
        );
    }
  }
  @media (min-width: 90rem) {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  > :first-child {
    filter: brightness(95%) grayscale(60%);
    font-size: 0.65em;
    margin-left: -1.25rem;
    @media (min-width: 48rem) {
      font-size: 0.8em;
      margin-bottom: 0;
    }
    @media (min-width: 64rem) {
      margin-left: -2rem;
    }
    @media (min-width: 90rem) {
      margin-left: 0;
    }
  }
  > :last-child {
    margin-left: -4rem;
    margin-right: -1.25rem;

    > :first-child {
      box-shadow:
        0 15px 60px -30px var(--section-color-dim),
        0 15px 60px -30px var(--section-color-dim-alt);
    }

    @media (min-width: 64rem) {
      margin-right: -8rem;
    }
  }
}
